import React from 'react'
import { object } from 'prop-types'

import useZdassetsScript from 'hooks/useZdassetsScript'

import Layout from 'layouts/Layout'
import ProductPage from 'components/CartridgePage/ProductPage'

const Product = ({ pageContext }) => {
  const { zdassetsScriptContainer } = useZdassetsScript()

  return (
    <Layout fullHeight lightFooter hideHeader>
      <ProductPage product={pageContext.product} />
      <div ref={zdassetsScriptContainer} />
    </Layout>
  )
}

Product.propTypes = {
  pageContext: object.isRequired
}

export default Product
